import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CPF_PATTERN } from 'src/app/app-config';
import { SnackBarService } from 'src/app/services/snack-bar.service';

@Component({
  selector: 'app-esqueci',
  templateUrl: './esqueci.component.html',
  styleUrls: ['./esqueci.component.css']
})
export class EsqueciComponent implements OnInit, OnDestroy {
  private userFormControl = new FormControl<string>("", [
    Validators.required,
    Validators.pattern(`^${CPF_PATTERN}$`),
    Validators.minLength(11)
  ]);
  private emailFormControl = new FormControl<string>("", [
    Validators.required,
    Validators.email
  ]);
  public esqueciFormGroup = new FormGroup({
    user: this.userFormControl,
    email: this.emailFormControl
  });

  public subscription?: Subscription;

  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private snackBarService: SnackBarService
  ) {
  }

  ngOnInit(): void {

  }
  ngOnDestroy(): void {
    this.unsubscribe();
  }
  private unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = undefined;
    }
  }

  private onOk() {
    this.snackBarService.exibirSucesso('Email de recuperação enviado');
    this.userFormControl.reset('');
    this.emailFormControl.reset('');
  }

  private onError(err: any) {
    console.log(`error: ${JSON.stringify(err)}`);
    let apiMessage: string | undefined;

    if (typeof err?.error === 'string') {
      try {
        const parsed = JSON.parse(err.error);
        apiMessage = parsed?.message;
      } catch {
        apiMessage = err.error;
      }
    } else {
      apiMessage = err?.error?.message;
    }

    this.snackBarService.exibirErro(apiMessage || 'Erro ao processar solicitação');
  }

  private getUrl() {
    return this.route.snapshot.queryParams["url"];
  }

  public onVoltar() {
    const url = this.getUrl();
    this.router.navigate([''], { queryParams: { url } });
  }

  public onEnviar() {
    this.unsubscribe();
    const user: string = this.userFormControl.value!.toString().replace(/\.|\-/g, "");
    const email: string = this.emailFormControl.value!.toString();
    const url = this.getUrl();
    this.subscription = this.httpClient.post(
      `/api/login/forgotpassword`,
      { user, email, url }, {
      responseType: "text"
    }).subscribe({
      next: (res) => {
        this.unsubscribe();
        this.onOk();
      },
      error: (err) => {
        this.unsubscribe();
        this.onError(err);
      }
    });
  }
}
